import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { myInternshipHistoryList } from "../user.api";
import moment from "moment";
import { useHistory } from "react-router-dom";
import BreadCrumpBack from "../../../components/navigator/back";
import "./style.css";

export default function RegisteredInternshipsHistory(props) {
  const history = useHistory();
  const [historyData, setHistoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const servInstance = (typeof process !== "undefined" && process.env?.REACT_APP_BASE_URL) || "";
  let result = servInstance
    ? servInstance.substring(0, servInstance?.length - 4)
    : "";

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = () => {
    setIsLoading(true);
    myInternshipHistoryList()
      .then((res) => {
        if (res?.success) {
          setHistoryData(res.data || []);
        } else {
          setSnackMessage("Failed to load internship history");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching history:", error);
        setSnackMessage("Error loading internship history");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const getBaseUrl = () => {
    const baseUrl = process?.env?.REACT_APP_BASE_URL || "http://127.0.0.1:8000/";
    return baseUrl.replace(/\/api\/?$/, "");
  };

  const resolvePath = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    const cleanBase = getBaseUrl().replace(/\/$/, "");
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${cleanBase}${cleanPath}`;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'certified': return '#28a745';
      case 'absorbed': return '#6f42c1';
      case 'evaluated': return '#007bff';
      default: return '#6c757d';
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case "certified":
        return "success";
      case "absorbed":
        return "primary";
      case "evaluated":
        return "info";
      default:
        return "secondary";
    }
  };

  return (
    <div className="registered-internships-page">
      <Loader open={isLoading} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="dash-banner">
        <div className="tit-txt">
          {props.state.language === "ma" ? "ഇന്റേൺഷിപ്പ് ഹിസ്റ്ററി" : "Internship History"}
        </div>
      </div>

      <BreadCrumpBack />

      <div className="container-fluid px-4 px-md-5 py-4">
        {historyData && historyData.length > 0 ? (
          <div className="row">
            {historyData.map((item, index) => (
              <div key={index} className="col-lg-6 mb-4">
                <div className="card internship-card h-100 border-0" style={{ borderLeft: `6px solid ${getStatusColor(item.status)}` }}>
                  <div className="card-body d-flex flex-column p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-2">
                      <div className="flex-grow-1">
                        <div className="company-info d-flex align-items-center mb-2">
                          {item.internship_request?.company?.logo ? (
                            <img
                              src={result + item.internship_request.company.logo}
                              alt="Logo"
                              className="company-logo-sm me-2 rounded"
                              style={{
                                width: "28px",
                                height: "28px",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            <div
                              className="company-logo-placeholder me-2 d-flex align-items-center justify-content-center bg-light text-muted small"
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "4px",
                              }}
                            >
                              <i className="fa fa-building"></i>
                            </div>
                          )}
                          <span
                            className="text-primary font-weight-bold"
                            style={{ fontSize: "0.85rem" }}
                          >
                            {item.internship_request?.company?.company_name || "Company Details N/A"}
                          </span>
                        </div>
                        <h5 className="card-title text-dark font-weight-bold mb-1" style={{ fontSize: "1.1rem" }}>
                          {item.internship_request?.internship_discipline || "Internship Program"}
                        </h5>
                      </div>
                      <span className={`badge bg-${getStatusBadgeClass(item.status)} text-white px-2 py-1`} style={{ fontSize: "0.75rem", borderRadius: "4px" }}>
                        {item.status?.toUpperCase()}
                      </span>
                    </div>

                    <div className="internship-details-container mt-2 mb-4 flex-grow-1" style={{ fontSize: "0.85rem" }}>
                      <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                        <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Duration</div>
                        <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                        <div className="col-12 col-sm-6 text-dark">
                          {moment(item.start_date).format("DD MMM YYYY")} - {moment(item.completion_date).format("DD MMM YYYY")}
                        </div>
                      </div>
                      <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                        <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Preference Order</div>
                        <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                        <div className="col-12 col-sm-6 text-dark font-weight-bold">#{item.preference_order}</div>
                      </div>
                      {item.evaluation_remarks && (
                        <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                          <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Remarks</div>
                          <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                          <div className="col-12 col-sm-6 text-dark fst-italic">"{item.evaluation_remarks}"</div>
                        </div>
                      )}
                    </div>

                    <div className="d-flex gap-2 mt-auto">
                      {item.joint_certificate_url || item.joint_certificate ? (
                        <div className="cert-tooltip-wrapper w-100">
                          <a
                            href={resolvePath(item.joint_certificate_url || item.joint_certificate)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success w-100 d-flex align-items-center justify-content-center py-2 font-weight-bold"
                            style={{ borderRadius: "6px", fontSize: "13px" }}
                          >
                            <i className="fa fa-certificate me-2"></i>
                            Download Certificate
                          </a>
                          <span className="cert-tooltip-text">
                            <i className="fa fa-info-circle me-1"></i>
                            You can collect the hard copy of the certificate from the KSUM office.
                          </span>
                        </div>
                      ) : (
                        <button
                          className="btn btn-light w-100 py-2 font-weight-bold text-muted"
                          style={{ borderRadius: "6px", fontSize: "13px" }}
                          disabled
                        >
                          Certificate Pending
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-5 bg-white rounded-4 border border-light shadow-sm">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="mb-3">
              <path d="M12 8v4l3 3" />
              <circle cx="12" cy="12" r="10" />
              <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" />
            </svg>
            <p className="text-muted font-weight-bold mb-1">
              {props.state.language === "ma" ? "ചരിത്രം ഒന്നും കണ്ടുകിട്ടിയില്ല" : "No Records Found"}
            </p>
            <p className="text-muted small">
              {props.state.language === "ma" ? "നിങ്ങളുടെ ഇന്റേൺഷിപ്പ് ഹിസ്റ്ററി ഇവിടെ ലഭ്യമല്ല." : "You don't have any completed internship records yet."}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
